/* Plennia PDP buy box — per-day (dry) / per-complete-meal (wet) pricing, feed meter, plan picker.
   Static asset; all product/locale data comes from data-* attributes on <plennia-product-detail>. */
(function(){
function initPDP(root){
  if(!root||root.dataset.pdpxInit)return;root.dataset.pdpxInit='1';
  var ES=root.dataset.es==='1';
  var variants=[];try{variants=JSON.parse(root.querySelector('[data-variants]').textContent);}catch(e){}
  var D=root.dataset;
  var form=D.form||'other';
  var energy=parseFloat(D.energy)||0, unitG=parseFloat(D.unitGrams)||0;
  var flow=parseFloat(D.flow)||1.2, wdef=parseFloat(D.wdef)||4;
  var bandLo=parseFloat(D.bandLo)||3, bandHi=parseFloat(D.bandHi)||6;
  var petEn=D.petEn||'pet',petEs=D.petEs||'mascota';
  var avgEs=petEs+' adulto medio', avgEn='average adult '+petEn;
  var actLabels={};actLabels[flow]=D.actLow||'';actLabels[parseFloat(D.fhigh)||1.4]=D.actHigh||'';
  var variantInput=root.querySelector('[data-variant-input]');
  var planInput=root.querySelector('[data-selling-plan]');
  var mode=root.hasAttribute('data-no-sub')?'onetime':'subscribe', chosenWeeks=null, cur=null, userChoseOnce=false;
  /* feed meter state: opens on the average adult animal (section w_def); becomes "your pet" once touched */
  var W=wdef, actF=flow, custom=false;
  function T(es,en){return ES?es:en;}
  function fmt(c){return (c/100).toLocaleString('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';}
  function num(n,d){return n.toLocaleString(ES?'es-ES':'en-IE',{minimumFractionDigits:d||0,maximumFractionDigits:d||0});}
  function wTxt(){return num(W,W%1?1:0)+' kg';}
  function weeksOf(n){var m=(n||'').match(/(\d+)\s*(?:week|semana)/i);return m?parseInt(m[1],10):0;}
  function plansOf(v){return (v&&v.plans||[]).map(function(p){return {id:p.id,price:p.price,weeks:weeksOf(p.name),name:p.name};}).filter(function(p){return p.weeks>0&&p.price>0;}).sort(function(a,b){return a.weeks-b.weeks;});}
  /* units in a pack: grams for dry ("2 kg"), complete meals for wet ("Tray 16×85g") */
  function units(v){
    if(!v)return 0;
    if(form==='dry')return v.grams>0?v.grams:0;
    if(form==='wet'){var m=(v.title||'').match(/(\d+)\s*[×x]/i);return m?parseInt(m[1],10):0;}
    return 0;}
  /* kcal/day = activity factor x 70 x BW^0.75 (RER x k) — same model the meter always used */
  function model(v,w){
    var u=units(v);if(!u||!energy)return null;
    var kd=actF*70*Math.pow(w,0.75);
    if(form==='dry'){var g=kd/(energy/1000);return {days:u/g,g:g,kcal:kd,u:u};}
    if(form==='wet'&&unitG){var md=kd/(unitG*energy/1000);return {days:u/md,meals:md,kcal:kd,u:u};}
    return null;}
  /* per-day (dry) or per-complete-meal (wet) cost of a given pack price */
  function perUnit(v,price,w){var m=model(v,w);if(!m)return 0;return form==='dry'?price/m.days:price/m.u;}
  function unitLong(){return form==='dry'?T('/ día','/ day'):T('/ comida','/ meal');}
  function unitShort(){return form==='dry'?T('/día','/day'):T('/comida','/meal');}
  function bagDays(v){var m=model(v,W);return m?m.days:0;}
  /* recommended cadence: the longest delivery interval the pack still covers, so the pet never runs out
     (1-day tolerance). Pack shorter than the shortest interval -> shortest interval + a hint. */
  function recPlan(v){var ps=plansOf(v);if(!ps.length)return null;
    var days=bagDays(v);
    if(!days)return ps.filter(function(p){return p.weeks===4;})[0]||ps[0];
    var ok=ps.filter(function(p){return p.weeks*7<=days+1;});
    return ok.length?ok[ok.length-1]:ps[0];}
  function pickPlan(v){var ps=plansOf(v);if(!ps.length)return null;
    if(chosenWeeks){var mm=ps.filter(function(p){return p.weeks===chosenWeeks;})[0];if(mm)return mm;}
    return recPlan(v);}
  function esc(t){return String(t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function packName(v){return form==='wet'?T('el pack de '+units(v),'the '+units(v)+'-pack'):T('el paquete de '+esc(v.title),'the '+esc(v.title)+' bag');}
  /* another subscribable format that fits the delivery rhythm better (bigger if this one runs out too fast, smaller if it lasts far too long) */
  function betterFormat(v,bigger){var ps=plansOf(v);if(!ps.length)return null;
    var minD=ps[0].weeks*7-1,maxD=ps[ps.length-1].weeks*7*1.3;
    var c=variants.filter(function(x){return x!==v&&x.available!==false&&plansOf(x).length&&bagDays(x);}).filter(function(x){var d=bagDays(x);return bigger?(d>bagDays(v)&&d>=minD):(d<bagDays(v)&&d>=minD);});
    c.sort(function(a,b){return bigger?bagDays(a)-bagDays(b):bagDays(b)-bagDays(a);});
    return c[0]||null;}
  function priceFor(v){var p=(mode==='subscribe')?pickPlan(v):null;return p?p.price:v.price;}
  function el(s){return root.querySelector(s);}
  function frame(){return custom?T('para tu '+petEs+' de '+wTxt(),'for your '+wTxt()+' '+petEn):T('coste medio · '+avgEs,'average cost · '+avgEn);}
  function cap(s){return s.charAt(0).toUpperCase()+s.slice(1);}
  function dayHead(v,price){var u=perUnit(v,price,W);return u?(fmt(u).replace(' €','')+'<small>€'+unitShort()+'</small>'):fmt(price);}

  function renderMeter(eff){
    var box=el('[data-pdpx]');if(!box)return;
    var m=model(cur,W);
    box.hidden=!m;
    var br=el('[data-x-bridge]'),dc=el('[data-x-disc]');
    if(!m){if(br)br.hidden=true;if(dc)dc.hidden=true;return;}
    var sl=el('[data-x-slider]');if(sl&&parseFloat(sl.value)!==W)sl.value=W;
    el('[data-x-weight]').textContent=wTxt();
    var md=el('[data-x-mode]');md.textContent=custom?T('Tu cálculo','Your figures'):(ES?avgEs:avgEn);md.classList.toggle('is-custom',custom);
    root.querySelectorAll('[data-x-acts] button').forEach(function(b){b.classList.toggle('on',Math.abs(parseFloat(b.dataset.f)-actF)<1e-9);});
    var rs=el('[data-x-reset]');rs.hidden=!custom;rs.textContent=T('Volver al '+avgEs,'Back to the '+avgEn);
    var out;
    if(form==='dry'){
      out=T('<b>'+num(m.g)+' g</b> al día, repartidos en 2 tomas · <b>'+num(m.kcal)+' kcal</b> · el paquete de '+cur.title+' dura <b>~'+num(m.days)+' días</b>',
            '<b>'+num(m.g)+' g</b> a day over 2 meals · <b>'+num(m.kcal)+' kcal</b> · the '+cur.title+' pack lasts <b>~'+num(m.days)+' days</b>');
    }else{
      out=T('<b>'+num(m.meals,1)+' comidas completas</b> al día, en al menos dos tomas · <b>'+num(m.kcal)+' kcal</b> · el pack de '+m.u+' cubre <b>~'+num(m.days)+' días</b>',
            '<b>'+num(m.meals,1)+' complete meals</b> a day, over at least two sittings · <b>'+num(m.kcal)+' kcal</b> · the '+m.u+'-pack covers <b>~'+num(m.days)+' days</b>');
    }
    el('[data-x-out]').innerHTML=out;
    /* headline figure */
    var u=perUnit(cur,eff,W);
    el('[data-x-num]').textContent=fmt(u).replace(' €','');
    el('[data-x-unit]').textContent='€ '+unitLong();
    var plan=pickPlan(cur);
    el('[data-x-unit2]').textContent=(mode==='subscribe'&&plan)?T('en suscripción','on subscription'):T('compra única','buy once');
    var lead=(form==='dry')
      ?T(cap(frame())+' · '+num(m.g)+' g al día · el paquete de '+cur.title+' dura <b>~'+num(m.days)+' días</b>.',
         cap(frame())+' · '+num(m.g)+' g a day · the '+cur.title+' pack lasts <b>~'+num(m.days)+' days</b>.')
      :T(cap(frame())+' · <b>'+num(m.meals,1)+' comidas completas</b> al día · el pack de '+m.u+' cubre <b>~'+num(m.days)+' días</b>.',
         cap(frame())+' · <b>'+num(m.meals,1)+' complete meals</b> a day · the '+m.u+'-pack covers <b>~'+num(m.days)+' days</b>.');
    el('[data-x-for]').innerHTML=lead+' &nbsp;<button type="button" class="pdpx-own" data-x-own>'+T('Calcula el de tu '+petEs,'Work out yours')+'</button>';
    var rg=el('[data-x-range]'),txt='';
    if(!custom){
      var lo=model(cur,bandLo),hi=model(cur,bandHi);
      if(lo&&hi){
        txt=(form==='dry')
          ?T('Entre '+fmt(eff/lo.days)+' y '+fmt(eff/hi.days)+' al día para '+petEs+'s de '+bandLo+'–'+bandHi+' kg.','Between '+fmt(eff/lo.days)+' and '+fmt(eff/hi.days)+' a day for '+bandLo+'–'+bandHi+' kg '+petEn+'s.')
          :T('Un '+petEs+' de '+bandLo+'–'+bandHi+' kg toma entre '+num(lo.meals,1)+' y '+num(hi.meals,1)+' comidas completas al día.','A '+bandLo+'–'+bandHi+' kg '+petEn+' eats between '+num(lo.meals,1)+' and '+num(hi.meals,1)+' complete meals a day.');
      }
    }
    rg.textContent=txt;
    if(br){br.hidden=false;br.innerHTML='<b>=</b>'+((form==='dry')
      ?T(fmt(eff)+' ÷ '+num(m.days)+' días de comida ('+num(m.g)+' g/día)',fmt(eff)+' ÷ '+num(m.days)+' days of food ('+num(m.g)+' g/day)')
      :T(fmt(eff)+' ÷ '+m.u+' comidas completas',fmt(eff)+' ÷ '+m.u+' complete meals'));}
    if(dc){dc.hidden=false;dc.textContent=T('Estimación según la guía de alimentación · ','Estimate based on the feeding guide · ')+(custom?wTxt():(ES?avgEs:avgEn)+', '+wTxt())+' · '+(actLabels[actF]||'').toLowerCase();}
  }

  function renderFormats(){
    root.querySelectorAll('.plennia-pdp__format').forEach(function(b){
      var v=variants.filter(function(x){return String(x.id)===String(b.dataset.variantId);})[0];if(!v)return;
      var sp=b.querySelector('[data-fmt-price]');if(!sp)return;
      var pr=priceFor(v),u=perUnit(v,pr,W);
      sp.textContent=u?(fmt(u)+' '+unitLong()+' · '+fmt(pr)):fmt(pr);
    });
  }

  function render(){
    if(!cur)return;
    var ps=plansOf(cur),plan=pickPlan(cur);
    var subCard=el('[data-p3="subscribe"]'),onceCard=el('[data-p3="onetime"]');
    if(!ps.length){mode='onetime';if(subCard)subCard.hidden=true;}
    else if(subCard){subCard.hidden=false; if(mode==='onetime'&&!userChoseOnce&&!root.hasAttribute('data-no-sub'))mode='subscribe';}
    var base=cur.price,sub=plan?plan.price:base;
    var hasModel=!!model(cur,W);
    if(subCard&&plan){
      var sh=el('[data-p3-subhead]');
      if(hasModel){sh.innerHTML='<span class="pdp3-day">'+dayHead(cur,sub)+'</span>';}
      else{sh.innerHTML='<s>'+fmt(base)+'</s><b>'+fmt(sub)+'</b>';}
      var sl=el('[data-p3-subline]');if(sl)sl.textContent=fmt(sub)+T(' cada entrega · envío gratis',' per delivery · free shipping')+(hasModel?T(' · antes '+fmt(base),' · was '+fmt(base)):'');
      var save=el('[data-p3-save]');
      var perSave=hasModel?(perUnit(cur,base,W)-perUnit(cur,sub,W)):0;
      save.innerHTML=T('Ahorras '+fmt(base-sub)+' en cada entrega','You save '+fmt(base-sub)+' per delivery')+(perSave>0?' <i>('+fmt(perSave)+unitShort()+')</i>':'');
      var fq=el('[data-p3-freq]');fq.innerHTML='';
      var rec=recPlan(cur);
      ps.forEach(function(p){var b=document.createElement('span');b.className='pdp3-fbtn'+(p.weeks===plan.weeks?' on':'')+(rec&&p.weeks===rec.weeks&&model(cur,W)?' is-rec':'');if(rec&&p.weeks===rec.weeks&&model(cur,W))b.title=T('Recomendado','Recommended');b.setAttribute('role','button');b.textContent=p.weeks+T(' sem',' wks');b.dataset.w=p.weeks;fq.appendChild(b);});
      var fit=el('[data-p3-fit]');
      if(fit){
        var days=bagDays(cur);
        if(days&&rec){
          var whoA=custom?T('a tu '+petEs,'your '+petEn):T('al '+avgEs,'the '+avgEn);
          var whoP=custom?T('para tu '+petEs,'for your '+petEn):T('para el '+avgEs,'for the '+avgEn);
          var t,warn=false,short=days<ps[0].weeks*7-1;
          if(short&&plan.weeks===rec.weeks){
            warn=true;var big=betterFormat(cur,true);
            t=T('<b>'+cap(packName(cur))+' dura ~'+num(days)+' días</b> '+whoP+', menos que la entrega más corta ('+ps[0].weeks+' semanas). ',
                '<b>'+cap(packName(cur))+' lasts ~'+num(days)+' days</b> '+whoP+', less than the shortest delivery ('+ps[0].weeks+' weeks). ');
            t+=big?T('<button type="button" class="pdp3-auto" data-x-fmt="'+big.id+'">El formato '+esc(big.title)+'</button> encaja mejor.',
                     '<button type="button" class="pdp3-auto" data-x-fmt="'+big.id+'">The '+esc(big.title)+' format</button> fits better.')
                  :T('Para la ración completa añade más packs en el carrito.','For the full ration add more packs in the cart.');
          }else if(plan.weeks===rec.weeks){
            t=T('<b>Ajustado '+whoA+':</b> '+packName(cur)+' dura ~'+num(days)+' días → entrega cada '+plan.weeks+' semanas.',
                '<b>Matched to '+whoA+':</b> '+packName(cur)+' lasts ~'+num(days)+' days → delivery every '+plan.weeks+' weeks.');
          }else{
            var gap=plan.weeks*7-days;warn=gap>1;
            t=(gap>1)?T('Cada '+plan.weeks+' semanas te quedarías sin comida ~'+num(gap)+' días antes.','Every '+plan.weeks+' weeks you would run out ~'+num(gap)+' days early.')
                     :T('Cada '+plan.weeks+' semanas te sobrarían ~'+num(-gap)+' días de comida en cada entrega.','Every '+plan.weeks+' weeks you would have ~'+num(-gap)+' days of food left over each time.');
            t+=' <button type="button" class="pdp3-auto" data-p3-auto>'+T('Usar cada '+rec.weeks+' semanas','Use every '+rec.weeks+' weeks')+'</button>';
          }
          if(short){}else if(days>ps[ps.length-1].weeks*7*1.3){
            var sm=betterFormat(cur,false);
            if(sm)t+=T(' Sobra comida incluso cada '+ps[ps.length-1].weeks+' semanas: <button type="button" class="pdp3-auto" data-x-fmt="'+sm.id+'">el formato '+esc(sm.title)+'</button> se mantiene más fresco.',
                       ' Food is left over even every '+ps[ps.length-1].weeks+' weeks: <button type="button" class="pdp3-auto" data-x-fmt="'+sm.id+'">the '+esc(sm.title)+' format</button> stays fresher.');
          }
          fit.innerHTML=t;fit.classList.toggle('is-warn',warn);
        }else{fit.textContent='';fit.classList.remove('is-warn');}
      }
    }
    if(onceCard){
      var oh=el('[data-p3-oncehead]');
      if(hasModel)oh.innerHTML='<span class="pdp3-day">'+dayHead(cur,base)+'</span>';else oh.innerHTML='<b>'+fmt(base)+'</b>';
      var ol=el('[data-p3-onceline]');if(ol)ol.textContent=hasModel?(fmt(base)+T(' · envío gratis desde 49 €',' · free shipping from 49 €')):'';
    }
    if(subCard)subCard.classList.toggle('is-active',mode==='subscribe');
    if(onceCard)onceCard.classList.toggle('is-active',mode==='onetime');
    var eff=(mode==='subscribe'&&plan)?sub:base;
    var lbl=el('[data-cta-label]');
    var soldOut=(cur.available===false);
    var soldOutTxt=(window.variantStrings&&window.variantStrings.soldOut)||T('Agotado','Sold out');
    if(lbl)lbl.textContent=soldOut?soldOutTxt:((mode==='subscribe'&&plan)?T('Empezar mi suscripción','Start my subscription'):T('Añadir al carrito','Add to cart'));
    var mi=el('.pdp3-micro');if(mi)mi.hidden=!(mode==='subscribe'&&plan);
    root.querySelectorAll('[data-cta-price]').forEach(function(e){e.textContent='— '+fmt(eff);});
    if(variantInput){variantInput.value=cur.id;variantInput.disabled=soldOut;}
    var sbtn=el('.plennia-pdp__form button[type=submit]');if(sbtn)sbtn.disabled=soldOut;
    if(planInput){if(mode==='subscribe'&&plan){planInput.value=plan.id;planInput.disabled=false;}else{planInput.value='';planInput.disabled=true;}}
    var sp=el('[data-sticky-price]');if(sp)sp.textContent=fmt(eff);
    var sb=el('[data-sticky-add]');if(sb){sb.disabled=soldOut;sb.textContent=soldOut?soldOutTxt:((mode==='subscribe'&&plan)?T('Suscribirme','Subscribe'):T('Añadir','Add to cart'));}
    renderMeter(eff);
    renderFormats();
  }

  function selectFormat(id){var fb=root.querySelector('.plennia-pdp__format[data-variant-id="'+id+'"]');if(fb&&!fb.disabled){fb.click();return;}
    cur=variants.filter(function(v){return String(v.id)===String(id);})[0]||cur;chosenWeeks=null;render();}
  root.addEventListener('click',function(ev){
    if(ev.target.closest('[data-p3-auto]')&&!ev.target.closest('[data-x-fmt]')){chosenWeeks=null;mode='subscribe';render();return;}
    var xf=ev.target.closest('[data-x-fmt]');
    if(xf){mode='subscribe';selectFormat(xf.dataset.xFmt);return;}
    var f=ev.target.closest('.pdp3-fbtn');
    if(f){chosenWeeks=parseInt(f.dataset.w,10);mode='subscribe';userChoseOnce=false;render();return;}
    var pc=ev.target.closest('[data-p3]');
    if(pc){mode=pc.dataset.p3;userChoseOnce=(mode==='onetime');render();return;}
    var ab=ev.target.closest('[data-x-acts] button');
    if(ab){actF=parseFloat(ab.dataset.f)||actF;custom=true;chosenWeeks=null;render();return;}
    if(ev.target.closest('[data-x-reset]')){W=wdef;actF=flow;custom=false;chosenWeeks=null;render();return;}
    if(ev.target.closest('[data-x-own]')){custom=true;render();var s=el('[data-x-slider]');if(s){s.focus();s.scrollIntoView({block:'center',behavior:'smooth'});}return;}
    var fb=ev.target.closest('.plennia-pdp__format');
    if(fb&&!fb.disabled){root.querySelectorAll('.plennia-pdp__format').forEach(function(b){b.classList.remove('is-active');});
      fb.classList.add('is-active');
      var id=fb.dataset.variantId;cur=variants.filter(function(v){return String(v.id)===String(id);})[0]||cur;
      chosenWeeks=null;render();return;}
  });
  var slider=el('[data-x-slider]');
  if(slider)slider.addEventListener('input',function(){W=parseFloat(slider.value)||wdef;custom=true;chosenWeeks=null;render();});
  var sticky=root.querySelector('[data-sticky]');
  var addBtn=root.querySelector('[data-sticky-add]');
  var mainSubmit=root.querySelector('.plennia-pdp__form button[type=submit]');
  if(addBtn&&mainSubmit)addBtn.addEventListener('click',function(){mainSubmit.click();});
  if(sticky)window.addEventListener('scroll',function(){sticky.hidden=!(window.scrollY>520);},{passive:true});
  var act=root.querySelector('.plennia-pdp__format.is-active');
  var aid=act?act.dataset.variantId:null;
  cur=variants.filter(function(v){return aid?String(v.id)===String(aid):v.available;})[0]||variants[0];
  // Leak fix (Jul 2026): when the pre-selected variant is one-off-only (e.g. the single
  // 16-tray, whose plans array is empty), default to a subscribable (plan-bearing) variant
  // so wet PDPs open on Subscribe rather than Buy once. Dry/treat PDPs (data-no-sub) skip this.
  if(!root.hasAttribute('data-no-sub') && (!cur || !plansOf(cur).length)){
    var subv=variants.filter(function(v){return v.available && plansOf(v).length;})[0];
    if(subv){ cur=subv;
      root.querySelectorAll('.plennia-pdp__format').forEach(function(b){b.classList.toggle('is-active',String(b.dataset.variantId)===String(subv.id));});
    }
  }
  render();
}
function boot(){document.querySelectorAll('plennia-product-detail.plennia-pdp--pilot').forEach(initPDP);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();